var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileYoutubeİcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6043 16.3333L16.249 14.2347L12.6043 12.1361V16.3333Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.7314 28 28 21.7314 28 14C28 6.26855 21.7314 0 14 0C6.26855 0 0 6.26855 0 14C0 21.7314 6.26855 28 14 28ZM20.7118 10.8669C20.55 10.2676 20.0771 9.79362 19.4779 9.63411C18.3818 9.33333 14 9.33333 14 9.33333C14 9.33333 12.798 9.33333 11.4958 9.37435C10.312 9.41309 9.04395 9.486 8.52213 9.62272C7.93424 9.78223 7.45003 10.2676 7.28825 10.8669C7 11.9629 7 14.2347 7 14.2347C7 14.2347 7 16.5179 7.28825 17.6025C7.45003 18.2018 7.92285 18.6735 8.52213 18.8353C9.62956 19.1361 14 19.1361 14 19.1361C14 19.1361 15.4139 19.1361 16.8369 19.0837C17.9181 19.0426 19.005 18.972 19.4779 18.8467C20.0771 18.6849 20.55 18.2132 20.7118 17.6139C21 16.5179 21 14.2461 21 14.2461C21 14.2461 21.0114 11.9629 20.7118 10.8669Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileYoutubeİcon);
export default __webpack_public_path__ + "static/media/mobile-youtube-icon.67a2ac04a2f3156632c8026b6d1ac736.svg";
export { ForwardRef as ReactComponent };